<template>
  <div ref="metadataTab">
    <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.referenceable)" id="reference-name">
      <panel-item>
        <row>
          <column>
            <label :for="selectedObjectModelRelation.idForProp('reference_name')">Reference Name</label>
          </column>
          <suffix>
            <help-tooltip text="Use this value to refer to the relationship via API."></help-tooltip>
          </suffix>
        </row>
        <expandable-textarea
          :id="selectedObjectModelRelation.idForProp('reference_name')"
          :value="selectedObjectModelRelation.reference_name"
          disabled
          placeholder="Enter a reference name for APIs"></expandable-textarea>
      </panel-item>
    </panel-block>

    <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.indexable)">
      <panel-item>
        <label :for="selectedObjectModelRelation.idForProp('indexable')">Index Relation</label>
        <yes-no-select
          v-model="selectedObjectModel.indexed_relation_client_ids"
          bind-by-array
          :val="selectedObjectModelRelation.client_id"
          :id="selectedObjectModelRelation.idForProp('indexable')"
          compress
        ></yes-no-select>
      </panel-item>
    </panel-block>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ObjectModelRelationCapability} from "../../../common/models/objectModelRelations/objectModelRelationCapability";
  import selectedMixin from "../mixins/selectedMixin";
  import {ObjectModelRelationType} from "~/enums/objectModelRelationType";
  import YesNoSelect from "../../../common/components/yesNoSelect.vue";

  export default Vue.extend({
    mixins: [selectedMixin],
    components: {
      YesNoSelect,
    },
    data: function () {
      return {
        ObjectModelRelationCapability,
      };
    },
    computed: {
      isAccountRelationship(): boolean {
        return this.selectedObjectModelRelation.relation_type === ObjectModelRelationType.Account;
      },
      label(): string {
        if (this.isAccountRelationship) {
          return "Relationship Name";
        } else {
          return "Role of this Object Model";
        }
      },
      placeholder(): string {
        if (this.isAccountRelationship) {
          return "Enter account name...";
        } else {
          return "Enter relationship name...";
        }
      }
    }
  });
</script>